/**
 * @param form1262ReturningUserData {object}
 * @returns {undefined | string}
 */
module.exports = function getForm1262ReturningUserEmail(form1262ReturningUserData) {
    if (form1262ReturningUserData) {
        return form1262ReturningUserData['Email'];
    }

    return undefined;
};